module.exports = __webpack_public_path__ + "img/vertical_5_1_9006.14ff8ce8.png";